<template>
  <div class="container-fluid mt--12">
    <actions-declaracao-inss/>
    <div class="row">
      <div class="col-sm-12 col-lg-12">
        <cadastro-declaracao-inss/>
      </div>
    </div>
  </div>
</template>

<script>
import DeclaracaoInssCadastroDetalhado from "./DeclaracaoInssCadastroDetalhado";
import DeclaracaoInssActions from "./DeclaracaoInssActions";
export default {
  name: "DeclaracaoInssContainerCadastro",
  components: {
    "cadastro-declaracao-inss": DeclaracaoInssCadastroDetalhado,
    "actions-declaracao-inss": DeclaracaoInssActions
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/declaracao/DeclaracaoInssContainerCadastro.vue